"use client"

import {
  InfiniteTable,
  type TableItem,
  TableSkeleton,
} from "@/app/components/infinite-table/infinite-table"
import { HeaderRow } from "@/app/components/table"
import type { ActivityWithNft } from "@anaconda/core/activity/types"
import { reatomComponent } from "@reatom/react"
import { Cell } from "./cells"
import { COLUMNS } from "./columns"
import { useActivityItems } from "./use-activity-items"

const COMPONENTS = {
  HeaderRow: CollectionHeaderRow,
  RowContent,
  RowSkeleton,
} as const

const getItemKey = (item: ActivityWithNft) => item.id

export const CollectionActivityTable = reatomComponent(() => {
  const { items, loadNext } = useActivityItems()

  return (
    <InfiniteTable
      getItemKey={getItemKey}
      items={items}
      loadNext={loadNext}
      components={COMPONENTS}
      initialItemCount={15}
    />
  )
}, "CollectionActivityTable")

export function CollectionActivityTableSkeleton() {
  return (
    <TableSkeleton HeaderRow={CollectionHeaderRow} RowSkeleton={RowSkeleton} />
  )
}

function CollectionHeaderRow() {
  return (
    <HeaderRow>
      {COLUMNS.map((column, index) => (
        <column.Header key={index} />
      ))}
    </HeaderRow>
  )
}

function RowContent({ content }: { content: ActivityWithNft }) {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <Cell key={index}>
          <column.Content {...content} />
        </Cell>
      ))}
    </>
  )
}

function RowSkeleton() {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <Cell key={index}>
          <column.Skeleton />
        </Cell>
      ))}
    </>
  )
}
